import { render } from "./PublishPopup.vue?vue&type=template&id=48ff1dfa&scoped=true"
import script from "./PublishPopup.vue?vue&type=script&lang=js"
export * from "./PublishPopup.vue?vue&type=script&lang=js"

import "./PublishPopup.vue?vue&type=style&index=0&id=48ff1dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ff1dfa"]])

export default __exports__